export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-04.414274f0.png";